import {
	getOnboardingState,
	type OnboardingState,
	type OnboardingStatus
} from '$lib/apis/content-factory/onboarding';

export type RegistrationIntroOnboardingStatePorts = {
	readState: (token: string) => Promise<Pick<OnboardingState, 'status'>>;
};

const browserPorts: RegistrationIntroOnboardingStatePorts = {
	readState: (token) => getOnboardingState(token)
};

export const isRegistrationIntroOnboardingIncomplete = (status: OnboardingStatus | string) =>
	!['completed', 'skipped'].includes(status);

export const readRegistrationIntroOnboardingState = async (
	token: string,
	ports: RegistrationIntroOnboardingStatePorts = browserPorts
) => {
	const state = await ports.readState(token);
	return {
		status: state.status,
		incomplete: isRegistrationIntroOnboardingIncomplete(state.status)
	};
};
